const KEYWORDS = [
  'külot', 'kulot', 'kilot', 'sutyen', 'sütyen', 'bra', 'panty', 'panties', 'underwear',
  'lingerie', 'slip', 'iç giyim', 'ic giyim', 'ic-giyim', 'tanga', 'string',
  'g-string', 'thong', 'babydoll', 'gecelik', 'jartiyer', 'garter', 'corset',
  'korse', 'teddy', 'seksi', 'sexy', 'erotic', 'erotik', 'fantazi', 'fantezi',
  'iç çamaşır', 'ic camasir', 'bikini', 'mayo', 'swimsuit', 'swimwear',
  'vücut zinciri', 'vucut zinciri', 'bel zinciri', 'body chain', 'waist chain',
  'bacak zinciri', 'göbek zinciri', 'belly chain', 'fileli çorap', 'nipple', 'meme ucu',
  'crotchless', 'açık bölge', 'open crotch', 'open bust', 'open chest',
  'fantezi giyim', 'fantezi-giyim', 'intimate', 'intimates', 'harness', 'clubwear',
  'body-harness', 'nightgown',
];

const LAUNDRY_BRA = /\bbra\s+(washing|protector|ball)\b/iu;
const MODEST_SWIM = /\b(hijab|tesettür|tesettur|fully covered|kapalı mayo)\b/iu;

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const SENSITIVE_PATTERN = new RegExp(
  `(^|[^\\p{L}\\p{N}])(?:${KEYWORDS.map(escapeRegExp).join('|')})(?:s|es|ed|ing)?(?=$|[^\\p{L}\\p{N}])`,
  'iu',
);

function productText(product) {
  return [
    product?.name,
    product?.name_tr,
    product?.category,
    product?.category_tr,
    product?.subcategory,
    product?.subcategory_tr,
    product?.category_path,
  ]
    .filter(Boolean)
    .join(' ');
}

/** Çıplak / iç giyim görseli. Çamaşır topu gibi yanlış eşleşmeler bulanıklaşmaz. */
export function shouldBlurSensitiveImage(product) {
  if (!product) return false;
  const blob = productText(product);
  if (LAUNDRY_BRA.test(blob) || MODEST_SWIM.test(blob)) return false;
  return SENSITIVE_PATTERN.test(blob);
}

/** Ana sayfadan çıkar: işaretli ürünler ve çıplak/iç giyim başlıkları. */
export function isSensitiveProduct(product) {
  if (!product) return false;
  if (shouldBlurSensitiveImage(product)) return true;
  const blob = productText(product);
  if (LAUNDRY_BRA.test(blob) || MODEST_SWIM.test(blob)) return false;
  return Boolean(product.is_sensitive || product.hide_from_homepage);
}

export function withoutSensitiveProducts(products) {
  return (products || []).filter((product) => !isSensitiveProduct(product));
}
